import {useTranslation} from 'react-i18next';
import './DropInQueueOnDevice.scss';
import {useParams} from 'react-router-dom';
import {useArrivalContext} from 'src/context/ArrivalContext';
import {Spinner} from '../layout/loader/Spinner';
import {useEffect, useState} from 'react';
import {DropinArrivalResponse} from '../../services/api/types/types';
import {fetchDropInArrival} from '../../services/api/api';

export function DropInQueueOnDevice() {
    const {t} = useTranslation();
    const {queueId} = useParams<{queueId: string}>();
    const arrivalId = parseInt(queueId || '', 10);
    const {
        dataState: {loading, clinicId}
    } = useArrivalContext();
    const [dropInInfo, setDropInInfo] = useState<DropinArrivalResponse>();

    useEffect(() => {
        const loadData = async function () {
            try {
                setDropInInfo(await fetchDropInArrival(clinicId, arrivalId));
            } catch (error) {
                console.error(error);
            }
            setTimeout(loadData, 30000);
        };

        loadData();
    }, [clinicId, arrivalId]);

    if (loading || !dropInInfo)
        return (
            <div style={{width: '100px', height: '100px', margin: '3rem auto'}}>
                <Spinner />
            </div>
        );

    const texts = t('arrival.booking_result.confirmed', {returnObjects: true}) as string[];

    return (
        <div className='arrival-dropindevice-completed'>
            <h1>{t('arrival.booking_result.confirmed_heading')}</h1>
            <p dangerouslySetInnerHTML={{__html: t('arrival.your_queue_number')}} />
            <div className='arrival-dropindevice-number-box'>{dropInInfo.queueNumber.toString().padStart(2, '0')}</div>
            <p>
                {texts.map((txt, ix) => (
                    <span key={ix}>
                        <span dangerouslySetInnerHTML={{__html: txt}} />
                        <br />
                    </span>
                ))}
            </p>
        </div>
    );
}
